var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_4680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_4680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.3H16.55V3.95C16.55 3.83065 16.5026 3.71619 16.4182 3.6318C16.3338 3.54741 16.2193 3.5 16.1 3.5C15.9807 3.5 15.8662 3.54741 15.7818 3.6318C15.6974 3.71619 15.65 3.83065 15.65 3.95V5.3H9.35V3.95C9.35 3.83065 9.30259 3.71619 9.2182 3.6318C9.13381 3.54741 9.01935 3.5 8.9 3.5C8.78065 3.5 8.66619 3.54741 8.5818 3.6318C8.49741 3.71619 8.45 3.83065 8.45 3.95V5.3H5.75C5.15348 5.30071 4.5816 5.538 4.1598 5.9598C3.738 6.3816 3.50071 6.95348 3.5 7.55V19.25C3.50071 19.8465 3.738 20.4184 4.1598 20.8402C4.5816 21.262 5.15348 21.4993 5.75 21.5H19.25C19.8466 21.4995 20.4186 21.2623 20.8405 20.8405C21.2623 20.4186 21.4995 19.8466 21.5 19.25V7.55C21.4995 6.95341 21.2623 6.38139 20.8405 5.95954C20.4186 5.53768 19.8466 5.30048 19.25 5.3ZM20.2046 19.5C20.2046 19.9219 20.2046 20.2046 20.2046 20.2046C20.2046 20.2046 19.608 20.2046 19.25 20.2046H5.75C5.39196 20.2046 5.14062 20.2046 4.79541 20.2046C4.79541 19.9141 4.79541 19.858 4.79541 19.5V11.6H20.2046V19.5ZM20.2046 10.7H4.79541V7.55C4.79541 6.8048 5.003 6.2 5.75 6.2H8.45V7.55C8.45 7.66935 8.49741 7.78381 8.5818 7.8682C8.66619 7.95259 8.78065 8 8.9 8C9.01935 8 9.13381 7.95259 9.2182 7.8682C9.30259 7.78381 9.35 7.66935 9.35 7.55V6.2H15.65V7.55C15.65 7.66935 15.6974 7.78381 15.7818 7.8682C15.8662 7.95259 15.9807 8 16.1 8C16.2193 8 16.3338 7.95259 16.4182 7.8682C16.5026 7.78381 16.55 7.66935 16.55 7.55V6.2H19.25C19.608 6.2 19.7468 6.24683 20 6.5C20.2532 6.75317 20.2046 7.01696 20.2046 7.375V10.7Z",
    fill: "#53B7E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceActive);
export default __webpack_public_path__ + "static/media/attendance_active.af694b1e48f06e98d77942504a5a0f2e.svg";
export { ForwardRef as ReactComponent };